import "./App.css";
import SideBar from "./components/SideBar";
import Home from "./components/Home";

function App() {
  return (
    <div className="app">
      <SideBar />
      <Home />
    </div>
  );
}

export default App;
